import React from 'react';
import { makeStyles } from '@mui/styles';
import Award01 from '../assets_2026/bluesign blue.png';
import Award02 from '../assets_new/frontpage/oeko-tex.png';
import Award03 from '../assets_new/frontpage/higg-index-logo.png';
import Award04 from '../assets_new/frontpage/grs-logo.png';
import Award05 from '../assets_new/frontpage/zdhc.jpg';

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: "90%",
    margin: "auto",
    paddingTop: "2%",
    paddingBottom: "2%",
  },
  title: {
    textAlign: "center",
  },
  awards: {
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "center",
    padding: 0,
    margin: 0,
    listStyle: "none",
    "& img": {
      maxHeight: "75px",
      padding: "5%"
    },

  },
  awardsContainer: {
    width: "80%",
    margin: "5px auto",
    listStyle: "none",
    display: "flex",
    justifyContent: "center",
    "& img": {
      maxHeight: "75px",
      padding: "5%"
    },
    "& li": {
      minWidth: "150px",
      maxWidth: "250px",
      textAlign: "center",
      display: "flex",
      flexWrap: "wrap",
      alignContent: "center",
      alignItems: "center",
    },
  },
  bluesignWrapper: {
    width: "80px",
    height: "75px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexShrink: 0,
  },
  bluesignImg: {
    height: "6rem",
    width: "auto",
    maxHeight: "none",
    flexShrink: 0,
    padding: "5%",
  },
}));


function Item(props) {
  const classes = useStyles();

  return (
    <li >
      <img src={props.image} alt="award" className={classes.item} style={props.style} />
    </li>
  );

}


function Awards() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ul className={classes.awardsContainer}>
        <li>
            <img src={Award01} alt="bluesign®" className={classes.bluesignImg} />
        </li>
        <Item image={Award02} style={{ maxHeight: "8rem" }} />
        <Item image={Award03} style={{ maxHeight: "5rem" }} />
        <Item image={Award04} style={{ maxHeight: "8em" }} />
        <Item image={Award05} style={{ maxHeight: "4.5rem" }}/>
      </ul>
    </div >
  );
}


export default Awards;
